import { Component, OnInit } from '@angular/core';
import { AbstractWidgetComponent } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';

@Component({
  selector: 'app-visitor-leave-failed',
  templateUrl: './visitor-leave-failed.component.html',
  styleUrls: ['./visitor-leave-failed.component.scss']
})
export class VisitorLeaveFailedComponent extends AbstractWidgetComponent implements OnInit {


  constructor(
  ) {
    super();
  }

  ngOnInit(): void {
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
  }

}
